export const LOGO_SRC = '/img/logo.png';
export const LOGO_WHITE_SRC = '/img/logo-white.png';

export const navLinks = [
    { label: 'الكورسات', route: 'courses' },
    { label: 'الدعم الفني', shortLabel: 'الدعم', route: 'help' },
];

export const categoryChips = [
    { label: 'الكل', active: true },
    { label: 'أولى ثانوي', variant: 'blue' },
    { label: 'تانية ثانوي', variant: 'cyan' },
    { label: 'كورسات إضافية', variant: 'navy' },
];

export const courseGradientPresets = [
    {
        bg: 'from-[#1a0a0a] via-[#2a0f0f] to-[#0a0a0a]',
        glow: 'from-[rgba(239,68,68,0.3)] via-[rgba(249,115,22,0.2)] to-transparent',
        icon: 'Auto',
        title: 'Automations',
        titleLine2: null,
        cardSubtitle: 'Automations & AI',
    },
    {
        bg: 'from-[#1a0505] via-[#2a0a0a] to-[#0a0000]',
        glow: 'from-[rgba(220,38,38,0.3)] via-[rgba(236,72,153,0.2)] to-transparent',
        icon: 'AI',
        title: 'AI For',
        titleLine2: 'Students',
        cardSubtitle: null,
    },
    {
        bg: 'from-[#1a0808] via-[#2a0d0d] to-[#0a0303]',
        glow: 'from-[rgba(244,63,94,0.3)] via-[rgba(239,68,68,0.2)] to-transparent',
        icon: '</>',
        title: 'Vibe Coding',
        titleLine2: null,
        cardSubtitle: null,
    },
    {
        bg: 'from-[#150505] via-[#280a0a] to-[#080000]',
        glow: 'from-[rgba(245,158,11,0.3)] via-[rgba(239,68,68,0.2)] to-transparent',
        icon: 'Py',
        title: 'Python',
        titleLine2: null,
        cardSubtitle: null,
    },
    {
        bg: 'from-[#1a0606] via-[#2c0d0d] to-[#0a0202]',
        glow: 'from-[rgba(239,68,68,0.3)] via-[rgba(225,29,72,0.2)] to-transparent',
        icon: '11',
        title: 'Grade 11',
        titleLine2: null,
        cardSubtitle: '٢ ثانوي',
    },
];

export const learningFeatures = [
    { icon: 'BookOpen', title: 'شرح بسيط', text: 'نشرح الفكرة خطوة بخطوة وبربطها بأمثلة من حياة الطالب.', color: 'blue' },
    { icon: 'Code2', title: 'تطبيق عملي', text: 'الطالب يكتب ويجرب، لأن البرمجة لا تُفهم بالمشاهدة فقط.', color: 'green' },
    { icon: 'ClipboardList', title: 'حل أسئلة', text: 'تدريب على أسئلة المنهج، الواجبات، والتقييمات بطريقة تفهّمك الفكرة.', color: 'cyan' },
    { icon: 'Sparkles', title: 'Coding Lab', text: 'مكان للتدريب العملي على كتابة الكود، التجربة، وتصحيح الأخطاء.', color: 'blue' },
    { icon: 'BookMarked', title: 'الكتاب التفاعلي', text: 'مذكرة منظمة للمنهج مع نقاط مهمة وأسئلة مرتبطة بكل درس.', color: 'cyan' },
    { icon: 'CheckCircle2', title: 'مراجعات مستمرة', text: 'مراجعات أسبوعية تراكمية ونهائية عشان الطالب ما يراكمش.', color: 'green' },
    { icon: 'Users', title: 'Community', text: 'مكان للطلاب يسألوا، يتابعوا، ويستفيدوا من أسئلة بعض.', color: 'blue' },
    { icon: 'Calendar', title: 'Calendar', text: 'خطة واضحة طول السنة تعرف الطالب يذاكر إيه وإمتى.', color: 'cyan' },
];

export const learningColorMap = {
    blue: { bg: 'bg-brand-blue', text: 'text-white', num: 'text-brand-blue-30' },
    cyan: { bg: 'bg-brand-cyan', text: 'text-white', num: 'text-brand-cyan-30' },
    green: { bg: 'bg-brand-green', text: 'text-white', num: 'text-brand-green-30' },
};

export const toolsData = [
    {
        icon: 'BookOpen',
        title: 'الكتاب التفاعلي',
        text: 'ذاكر المنهج بطريقة منظمة، افتح الدروس، راجع النقاط المهمة، وحل أسئلة مرتبطة بكل جزء.',
        cta: 'افتح الكتاب التفاعلي',
        accent: '#E63946',
        tint: 'from-[rgba(230,57,70,0.1)] to-transparent',
        mock: 'book',
    },
    {
        icon: 'Code2',
        title: 'Coding Lab',
        text: 'اكتب الكود بإيدك، جرّب الحل، شوف الأخطاء، واتعلم إزاي تصلّحها بنفسك.',
        cta: 'ادخل Coding Lab',
        accent: '#F26B5A',
        tint: 'from-[rgba(242,107,90,0.1)] to-transparent',
        mock: 'code',
    },
    {
        icon: 'ClipboardCheck',
        title: 'تدريب وامتحانات',
        text: 'اختبر نفسك بأسئلة قصيرة، مراجعات، ونماذج تساعدك تدخل الامتحان بثقة.',
        cta: 'ابدأ التدريب',
        accent: '#22C55E',
        tint: 'from-[rgba(34,197,94,0.1)] to-transparent',
        mock: 'quiz',
    },
    {
        icon: 'Calendar',
        title: 'Calendar المذاكرة',
        text: 'خطة واضحة تعرفك المفروض تذاكر إيه، تحل إيه، وتراجع إيه كل أسبوع.',
        cta: 'شوف الخطة',
        accent: '#E63946',
        tint: 'from-[rgba(230,57,70,0.1)] to-transparent',
        mock: 'calendar',
    },
];

export const aboutStats = [
    { value: '+10', label: 'سنين خبرة' },
    { value: '+5', label: 'شركات أسسها' },
    { value: '+2 مليون', label: 'طالب ساعد في تعليمهم' },
];

export const aboutCompanies = [
    {
        role: 'مؤسس',
        brand: 'YallaStep Group',
        desc: 'من أكبر الشركات في إنتاج المحتوى والمحتوى التعليمي، وقدّمت خدماتها لأكبر المؤسسات في الوطن العربي.',
    },
    {
        role: 'Co-Founder',
        brand: 'DerasaTech',
        desc: 'شريك مؤسس لشركة دراسة تك التي طوّرت المنصات التعليمية لأكبر المدرسين والمؤسسات في مصر والوطن العربي.',
    },
    {
        role: 'Co-Founder',
        brand: 'eijaaz',
        desc: 'شريك مؤسس لشركة إيجاز المتخصصة في حلول الذكاء الاصطناعي في التعليم.',
    },
];

export const aboutTags = ['Education', 'Technology', 'AI', 'EdTech', 'Media'];

export const ALL_LINKS_URL = 'https://start.codingwithghonaim.com/links';
export const LINKTREE = ALL_LINKS_URL;
export const REGISTER_URL = '/register';
export const YOUTUBE_URL = 'https://www.youtube.com/@CodingWithGhonaim';
export const TELEGRAM_URL = 'https://t.me/codingwithghonaim';
export const WHATSAPP_CHANNEL_URL = 'https://whatsapp.com/channel/0029Vb6z3DX3wtb8iKfkA21K';
export const WHATSAPP_URL = 'https://wa.me/201234511022';
export const IOS_APP_URL = 'https://apps.apple.com/eg/app/codingwithghonaim/id6778895200';
export const ANDROID_APP_URL = 'https://play.google.com/store/apps/details?id=com.codingwithghonaim.app';
